import { createAction, handleActions } from 'redux-actions';
import { useService } from '@piwikpro/platform';
import { Dispatch } from 'redux';

type PermissionsLevels = 'view' | 'edit' | 'publish' | 'delete' | 'manage' | 'add';

interface AccessControlEntityPermissionsResponse {
  data: {
    type: 'ppms/permission/entity/actions'
    id: string
    attributes: {
      actions: PermissionsLevels[]
    }
  }
}

export const checkAppPermissionsInitialized = createAction(
  '@platform/query/appPermissions/list/init',
);
export const checkAppPermissionsSucceeded = createAction<
Partial<AccessControlEntityPermissionsResponse['data']>, AccessControlEntityPermissionsResponse['data']>(
  '@platform/query/appPermissions/list/success',
  payload => payload,
);
export const checkAppPermissionsFailed = createAction(
  '@platform/query/appPermissions/list/failed',
);

/* eslint-disable-next-line */
export const checkAppPermissions = (id: string, userRole: string) => async (dispatch: Dispatch) => {
  const httpClient = useService('HttpCrate.httpClient');
  const config = useService('config');

  if (userRole === 'OWNER') {
    return dispatch(checkAppPermissionsSucceeded({
      id,
      type: 'ppms/permission/entity/actions',
      attributes: {
        actions: [
          'view',
          'edit',
          'manage',
        ],
      },
    }));
  }

  dispatch(checkAppPermissionsInitialized());

  try {
    const resp = await httpClient.request({
      endpoint: `${config.get('ACCESS_CONTROL_URL')}/entry/${id}`,
      method: 'GET',
    }).jsonApi().send();
    dispatch(checkAppPermissionsSucceeded(resp.data));
  } catch (err) {
    dispatch(checkAppPermissionsFailed());
  }
};

export type AppPermissionsState = {
  levels: PermissionsLevels[]
  isLoading: boolean
};

const initialState: AppPermissionsState = {
  levels: [],
  isLoading: true,
};

export default handleActions<AppPermissionsState, AccessControlEntityPermissionsResponse['data']>({
  [checkAppPermissionsInitialized.toString()]: () => initialState,
  [checkAppPermissionsSucceeded.toString()]: (state, { payload }) => ({
    ...state,
    isLoading: false,
    levels: payload.attributes.actions,
  }),
  [checkAppPermissionsFailed.toString()]: () => ({
    ...initialState,
    isLoading: false,
  }),
}, initialState);
